import { render, staticRenderFns } from "./group-info.vue?vue&type=template&id=991a879e&scoped=true"
import script from "./group-info.vue?vue&type=script&lang=js"
export * from "./group-info.vue?vue&type=script&lang=js"
import style0 from "./group-info.vue?vue&type=style&index=0&id=991a879e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991a879e",
  null
  
)

export default component.exports